import React from "react";
import { Dropdown } from "@culturehq/components";
import { Trans } from "app/utils";

const SocialChannelFilter = ({ filter, setFilter, socialMediaNames }) => {
  const selectedLabel = filter === "all" ? "All Social Channels" : socialMediaNames.find(name => name === filter) || "All Social Channels";

  return (
    <Dropdown selected={filter} onChange={setFilter}>
      <Dropdown.Button className="chq-btn Gray-Button">
        <Trans>{selectedLabel}</Trans>
      </Dropdown.Button>
      <Dropdown.ListBox className="custom_option dp-shg">
        <Dropdown.Option value="all">
          <Trans>All</Trans>
        </Dropdown.Option>
        {socialMediaNames.map(socialMediaName => (
          <Dropdown.Option key={socialMediaName} value={socialMediaName}>
            <Trans>{socialMediaName}</Trans>
          </Dropdown.Option>
        ))}
      </Dropdown.ListBox>
    </Dropdown>
  );
};

export default SocialChannelFilter;
